const DEFAULT_RXMISSION_BASE_URL = 'http://localhost:3000/';

/**
 * Bouwt de Rx.Mission-deeplink voor een zaak volledig client-side:
 * base-URL (VITE_RXMISSION_BASE_URL, met dummy-fallback) + het Zaaknummer.
 * De echte Rx.Mission-padstructuur is nog niet bekend; pas die hier aan
 * zodra die bekend is (bv. `?zaaknummer=Z2026-00002194`).
 */
export function buildRxMissionUrl(path: string): string {
  // Bewust binnen de functie gelezen (niet module-scope): testbaar via vi.stubEnv
  // en `||` i.p.v. `??` zodat een lege string ook op de fallback terugvalt.
  // Trim: GitHub Environments accepteren geen lege waarde, dus staan er
  // placeholders als ' ' in de vars, en een copy/paste laat makkelijk een \r\n
  // achter. Zonder trim gooit `new URL` op zo'n base een TypeError.
  const base =
    import.meta.env.VITE_RXMISSION_BASE_URL?.trim() || DEFAULT_RXMISSION_BASE_URL;
  // Zonder trailing slash vervangt `new URL` het laatste padsegment van de base.
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  return new URL(encodeURIComponent(path), normalizedBase).toString();
}
